import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';

import OrderViewInformationSection from './OrderViewInformationSection';
import OrderViewInformationSectionTitle from './OrderViewInformationSectionTitle';

const styles = () => ({
  listItem: {
    padding: 0,
    display: 'block',
    marginTop: 20,
  },
  gridItem: {
    display: 'flex',
  },
});
const OrderViewInformationDiagnoses = ({
  Diagnosis,
  classes,
}) => (
  <OrderViewInformationSection>
    <OrderViewInformationSectionTitle>
      Diagnoses
    </OrderViewInformationSectionTitle>
    <List disablePadding>
      {Diagnosis.map(diagnosesItem => (
        <ListItem
          key={diagnosesItem.ID}
          className={classes.listItem}
          disableGutters
        >
          <Typography component="span" gutterBottom>
            {diagnosesItem['DX Code']}
            {' '}
            {diagnosesItem['Long Description']}
          </Typography>
          {diagnosesItem.create_at &&
            <Typography
              variant="caption"
              component="span"
            >
              {diagnosesItem.create_at}
            </Typography>
          }
        </ListItem>
      ))}
    </List>
  </OrderViewInformationSection>
);

OrderViewInformationDiagnoses.propTypes = {
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'DX Code': PropTypes.string.isRequired,
    create_at: PropTypes.string,
  })).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
    gridItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrderViewInformationDiagnoses);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationDiagnoses.js